import { render, staticRenderFns } from "./NodeRemoveButton.vue?vue&type=template&id=96435b5a&scoped=true&"
import script from "./NodeRemoveButton.vue?vue&type=script&lang=js&"
export * from "./NodeRemoveButton.vue?vue&type=script&lang=js&"
import style0 from "./NodeRemoveButton.vue?vue&type=style&index=0&id=96435b5a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96435b5a",
  null
  
)

export default component.exports